import script from "./DetalharDespesa.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalharDespesa.vue?vue&type=script&setup=true&lang=js"

import "./DetalharDespesa.vue?vue&type=style&index=0&id=39ac79fb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ac79fb"]])

export default __exports__